<script>
import ComponentMapThumb from "./ComponentMapThumb.svelte";
//
// export let pageCopy;
// export let pageTitle;
// export let pageImage;
export let mapData;

//
let theTitle;
let baseURL = "https://strapi.understory.community";
let map1;
let map2;
let map3;
let map4;
// let theImg = pageImage[0];
// let imgURL = baseURL + theImg.formats.small.url // ""+ JSON.stringify(theImg.formats.small.url);
// let alt = theImg.alternativeText;
//
// if (pageTitle !== null) {
//     theTitle = pageTitle;

// } else {
//     theTitle = " ";
// }

if(mapData!== null){
map1 = mapData[0];
map2 = mapData[1];
map3 = mapData[2];
map4 = mapData[3];
}
</script>
<section>
    <h2>Latest Maps</h2>
    <div>
        <!-- <nav class="fic--promo-list"> -->
            <nav class="fic--promo-map-list2">
            
            <ul>
                <li>
                    <ComponentMapThumb  thumbData={map1} />
                </li>
                <li>
                    <ComponentMapThumb thumbData={map2} />
                </li>
                <li>
                    <ComponentMapThumb thumbData={map3} />
                </li>
                <li>
                    <ComponentMapThumb thumbData={map4} />
                </li>
            </ul>
        </nav>
    </div>
</section>